import { LatestUpdatesType } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';
import { useGetUploadedImageQuery } from '@Store/api/strapiApiSlice';
import { NewsIcon } from '../../components/NewsIcon';

import styles from './carousel-item.module.css';

interface CarouselItemProps {
  imageSrc: string;
  newsType: LatestUpdatesType;
  publishedAt: string;
  description: string;
}

const CarouselItem: React.FC<CarouselItemProps> = ({
  description,
  imageSrc,
  newsType,
  publishedAt,
}) => {
  const { data: strapiImage } = useGetUploadedImageQuery(imageSrc);
  return (
    <div className={styles.shorterPost}>
      <div className={styles.info}>
        <div className={styles.type}>
          <div>{NewsIcon[newsType]}</div>
          {newsType}
        </div>
        <div className={styles.desc}>{description}</div>
        <div className={styles.timePost}>
          {parseDateTime(publishedAt, 'DD.MM.YYYY HH:MM')}
        </div>
      </div>
      <img className={styles.imagePost} src={strapiImage} alt="News Post" />
    </div>
  );
};

export default CarouselItem;
